module.exports = __webpack_public_path__ + "img/reslove.dc91ce25.png";